export default "__VITE_ASSET__CQ6Dq8C5__"